import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

import { LayoutModule, SharedUiModule } from '@pf/shared-ui';
import { CpwTaskListItemComponent } from './cpw-task-list-item.component';
import { CpwTask } from '@cpw/domain';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { IconType } from '@pf/shared-common';

interface GroupedTasks {
    group: string;
    otherTasksTitle: string;
    oldestTaskIconType: keyof typeof IconType;
    oldestTaskPriority: boolean;
    oldestTask: CpwTask | null;
    otherTasks: CpwTask[];
}

@Component({
    selector: 'cpw-task-list',
    standalone: true,
    imports: [
        LayoutModule,
        SharedUiModule,
        CpwTaskListItemComponent,
        NzSpinComponent,
    ],
    templateUrl: './cpw-task-list.component.html',
    styleUrls: ['./cpw-task-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpwTaskListComponent implements OnChanges {
    @Input() title = '';
    @Input() tasks: CpwTask[] = [];
    @Input() emptyText = 'No tasks';
    @Input() loadingText = 'Loading tasks';
    @Input() loading = true;
    @Input() collapseAll = false;
    @Output() taskSelected = new EventEmitter<CpwTask>();

    groupedTasks: GroupedTasks[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tasks']) {
            this.groupAndSortTasks();
        }
    }

    private groupAndSortTasks(): void {
        const groups: { [key: string]: CpwTask[] } = {};
        for (const task of this.tasks) {
            if (!groups[task.group]) {
                groups[task.group] = [];
            }
            groups[task.group].push(task);
        }

        const sortedGroupKeys = Object.keys(groups).sort((a, b) => {
            if (a === 'Uniforms' && b !== 'Uniforms') return 1;
            if (b === 'Uniforms' && a !== 'Uniforms') return -1;
            return 0;
        });

        this.groupedTasks = sortedGroupKeys.map(group => {
            const sortedTasks = groups[group].sort(
                (a, b) =>
                    new Date(a.time).getTime() - new Date(b.time).getTime()
            );
            const oldestTask = this.collapseAll ? null : sortedTasks[0];
            const otherTasks = (
                this.collapseAll ? sortedTasks : sortedTasks.slice(1)
            ).map(task => ({ ...task, readonly: true }));
            return {
                group,
                oldestTask,
                oldestTaskIconType: sortedTasks[0].taskIconType,
                oldestTaskPriority: sortedTasks[0].priority,
                otherTasks,
                otherTasksTitle: `+ ${otherTasks.length} ${group} trips`,
            };
        });

        this.loading = false;
    }
}
